export var dialogContentOffset = 24;
export var MuiDialogContent = {
    styleOverrides: {
        root: {
            paddingBottom: 12,
            paddingTop: dialogContentOffset,
            '&:first-of-type': {
                paddingTop: dialogContentOffset,
            },
        },
    },
};
